import { Data } from '@blade/std-lib'

export type DownloadState =
  | DownloadStateInitial
  | DownloadStateInProgress
  | DownloadStateFinished

export class DownloadStateInitial extends Data.TaggedClass(
  'DownloadStateInitial',
)<{
  contentLength?: number | undefined
}> {}

export class DownloadStateInProgress extends Data.TaggedClass(
  'DownloadStateInProgress',
)<{
  contentLength?: number | undefined
  downloaded: number
}> {}
export class DownloadStateFinished extends Data.TaggedClass(
  'DownloadStateFinished',
)<{
  contentLength?: number | undefined
  downloaded: number
}> {}

export const addDownloaded =
  (downloaded: number) =>
  (state: DownloadState): DownloadState => {
    if (state._tag === 'DownloadStateFinished') {
      return state
    }
    if (state._tag === 'DownloadStateInProgress') {
      return new DownloadStateInProgress({
        contentLength: state.contentLength,
        downloaded: state.downloaded + downloaded,
      })
    }

    return new DownloadStateInProgress({
      contentLength: state.contentLength,
      downloaded: downloaded,
    })
  }

export const finish = (prevState: DownloadState) => {
  if (prevState._tag === 'DownloadStateFinished') {
    return prevState
  }

  if (prevState._tag === 'DownloadStateInProgress') {
    return new DownloadStateFinished({
      contentLength: prevState.contentLength,
      downloaded: prevState.downloaded,
    })
  }
  return new DownloadStateFinished({
    contentLength: prevState.contentLength,
    downloaded: 0,
  })
}
